import React, {useEffect, useRef, useState} from 'react'
import Tabs from './Tabs'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Icon, {icons} from '../Icons'
import {inputTypes} from '../../const'

import '../../css/SelectOffice.scss'

export default props => {
    const {
        officeName,
        officesTenerife,
        selectOffice,
        forceClose,
        setActiveInput,
        inputType,
        style,
        translations,
        ariaLabel,
        selectedOfficeId
    } = props
    

    const [areTabsVisible, setAreTabsVisible] = useState(false)
    const triggerRef = useRef(null)
    const listboxId = `office-options-${inputType}`
    
    useEffect(() => {
        if(areTabsVisible && forceClose) setAreTabsVisible(false)
    }, [areTabsVisible, forceClose])

    const setTabsVisible = visible => {
        setAreTabsVisible(visible)
        setActiveInput(visible ? inputType : inputTypes.none)
    }

    const inputClicked = () => {
        setTabsVisible(!areTabsVisible)
    }

    const handleTriggerKeyDown = event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault()
            if (!areTabsVisible) setTabsVisible(true)
        } else if (event.key === 'Escape' && areTabsVisible) {
            event.preventDefault()
            setTabsVisible(false)
        }
    }

    const closeAndFocusTrigger = () => {
        setTabsVisible(false)
        setTimeout(() => triggerRef.current && triggerRef.current.focus(), 0)
    }

    const handleSelectOffice = office => {
        selectOffice(office)
        closeAndFocusTrigger()
    }

    return (
        <div className="input-container" style={style}>
            <button
                type="button"
                className="selected-office"
                ref={triggerRef}
                aria-label={ariaLabel}
                aria-haspopup="listbox"
                aria-expanded={areTabsVisible}
                aria-controls={listboxId}
                onClick={inputClicked}
                onKeyDown={handleTriggerKeyDown}
            >
                <Icon icon={icons.car} className='icon-input' />
                <span className='office-name' >{officeName}</span>
                <FontAwesomeIcon icon='chevron-down' className='icon-input' />
            </button>
            
            {areTabsVisible && 
             <Tabs 
                translations={translations}
                className="tabs-offices" 
                officesTenerife={officesTenerife}
                selectOffice={handleSelectOffice}
                listboxId={listboxId}
                listboxLabel={ariaLabel}
                selectedOfficeId={selectedOfficeId}
                closeListbox={closeAndFocusTrigger}
              /> 
            }
        </div>
    )
}
